import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

const Header = () => {
    const location = useLocation()
    const [isMenuOpen, setIsMenuOpen] = useState(false)

    return (
        <header className="sticky top-0 z-50 w-full bg-white/90 backdrop-blur-sm border-b border-slate-100">
            <div className="mx-auto flex max-w-7xl items-center justify-between px-4 sm:px-6 py-4 sm:py-5">
                <div className="flex items-center gap-2">
                    <div className="text-primary">
                        <Link to="/">
                            <img src={process.env.PUBLIC_URL + "/Logo3.svg"} alt='img' className="w-16 h-16 sm:w-20 sm:h-20 object-contain" />
                        </Link>
                    </div>
                    <h2 className="text-lg sm:text-xl font-bold tracking-tight text-primary">
                        Tutor Match AE
                    </h2>
                </div>

                {/* Desktop Navigation */}
                <nav className="hidden lg:flex items-center gap-10">
                    <Link
                        className={`text-sm font-medium transition-colors ${location.pathname === '/'
                            ? 'text-primary font-semibold'
                            : 'text-slate-600 hover:text-primary'
                            }`}
                        to="/"
                    >
                        Home
                    </Link>
                    <Link
                        className={`text-sm font-medium transition-colors ${location.pathname === '/about'
                            ? 'text-primary font-semibold'
                            : 'text-slate-600 hover:text-primary'
                            }`}
                        to="/about"
                    >
                        About Us
                    </Link>
                    <Link
                        className={`text-sm font-medium transition-colors ${location.pathname === '/faq'
                            ? 'text-primary font-semibold'
                            : 'text-slate-600 hover:text-primary'
                            }`}
                        to="/faq"
                    >
                        FAQ
                    </Link>
                    <Link
                        className={`text-sm font-medium transition-colors ${location.pathname === '/contact'
                            ? 'text-primary font-semibold'
                            : 'text-slate-600 hover:text-primary'
                            }`}
                        to="/contact"
                    >
                        Contact Us
                    </Link>
                </nav>

                {/* Mobile Menu Button */}
                <button
                    className="lg:hidden p-2 text-slate-600 hover:text-primary"
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                >
                    <span className="material-symbols-outlined">
                        {isMenuOpen ? 'close' : 'menu'}
                    </span>
                </button>
            </div>

            {/* Mobile Navigation */}
            {isMenuOpen && (
                <div className="lg:hidden bg-white border-t border-slate-100">
                    <nav className="flex flex-col px-6 py-4 space-y-4">
                        <Link
                            className={`text-sm font-medium transition-colors ${location.pathname === '/'
                                ? 'text-primary font-semibold'
                                : 'text-slate-600 hover:text-primary'
                                }`}
                            to="/"
                            onClick={() => setIsMenuOpen(false)}
                        >
                            Home
                        </Link>
                        <Link
                            className={`text-sm font-medium transition-colors ${location.pathname === '/about'
                                ? 'text-primary font-semibold'
                                : 'text-slate-600 hover:text-primary'
                                }`}
                            to="/about"
                            onClick={() => setIsMenuOpen(false)}
                        >
                            About Us
                        </Link>
                        <Link
                            className={`text-sm font-medium transition-colors ${location.pathname === '/faq'
                                ? 'text-primary font-semibold'
                                : 'text-slate-600 hover:text-primary'
                                }`}
                            to="/faq"
                            onClick={() => setIsMenuOpen(false)}
                        >
                            FAQ
                        </Link>
                        <Link
                            className={`text-sm font-medium transition-colors ${location.pathname === '/contact'
                                ? 'text-primary font-semibold'
                                : 'text-slate-600 hover:text-primary'
                                }`}
                            to="/contact"
                            onClick={() => setIsMenuOpen(false)}
                        >
                            Contact Us
                        </Link>
                    </nav>
                </div>
            )}
        </header>
    )
}

export default Header